import { InputLabel as IL, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

export const InputLabel = ({ caption }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return <IL sx={{ bgcolor: theme.palette.mode === "dark" ? "#000" : "#fff" }}>{t(caption)}</IL>;
};
